import { Controller } from '@hotwired/stimulus';

/**
 * Slim address controller — only handles deletion.
 * Create / Edit is delegated to the generic `modal-form` controller.
 */
export default class extends Controller {

    static values = {
        deleteUrl: String,
    };

    declare readonly deleteUrlValue: string;

    async deleteAddress(e: Event): Promise<void> {
        e.preventDefault();
        const btn = e.currentTarget as HTMLElement;
        const id  = btn.dataset.id;
        if (!id) return;

        const url = this.deleteUrlValue.replace('/0', '/' + id);
        const res = await fetch(url, {
            method: 'DELETE',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });
        const json = await res.json();
        if (!json.success) return;

        const row = btn.closest('[data-address-id]');
        if (row) row.remove();

        // If no addresses left, show the empty state
        const tbody = this.element.querySelector('tbody');
        if (tbody && tbody.querySelectorAll('tr').length === 0) {
            const tableWrapper = this.element.querySelector('.table-responsive');
            if (tableWrapper) {
                tableWrapper.outerHTML =
                    `<div class="alert alert-info mb-0">No hay direcciones registradas.</div>`;
            }
        }
    }
}
